module.exports = __webpack_public_path__ + "static/media/piggy-bank.702f055e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/agsm/img/piggy-bank.png
 ** module id = 1663
 ** module chunks = 0
 **/